import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ASSETS_URL } from "../../components/Store";
import { Img } from "../../components/shared/img";
import _ from "lodash";
import useIsMobile from "../../js/utilities/useIsMobile";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, Pagination, A11y } from "swiper";
import { useLanguage } from "../../hooks/use-language";
import { useTranslationsById } from "../../hooks/use-translations-by-id";

/**
 * Componente que retorna la fila con los paises.
 * @property {array} group - arreglo que contiene la lista de lecturas
 * @property {string} category - nombre de la categoria
 * @property {string} text -  descripcion de la fila
 * @returns {JSX.Element} Countries
 */
export const Countries = ({ text, category, group, navigationButtons }) => {
    const lang = useLanguage();
    const texts = useTranslationsById({ mainSectionName: "libros", language: lang });

    const isMobile = useIsMobile();

    const swiperRef = useRef(null);
    const updateNavigation = (swiper) => {
        swiper.params.navigation.prevEl = navigationButtons?.prevButtonRef?.current
        swiper.params.navigation.nextEl = navigationButtons?.nextButtonRef?.current
        swiper.navigation.destroy()
        swiper.navigation.init()
        swiper.navigation.update()
    }

    const [isNavigation, setNavigation] = useState(window.innerWidth < 768 ? true : false);

    useEffect(() => {
        const setM = () => {
            let validacion;
            if (window.innerWidth < 768) {
                validacion = true;
            } else {
                validacion = false;
            }
            setNavigation(validacion)
        }
        setM();
        window.addEventListener('resize', setM)
        return () => {
            window.removeEventListener('resize', setM)
        }
    }, [])

    return (
        <>
        <div className="d-xl-flex mt-3">
            <div className="d-none d-xl-block col-description px-0" style={{ height: 170 }}>
                <p>{text}</p>
            </div>
            <div className="col-books pl-xl-3 pr-0">
                <div className="d-flex justify-content-between" role="region" >
                    {
                        isMobile ?
                            <Swiper
                                ref={swiperRef}
                                className={`w-100 swiper-descriptive-row country-swiper`}
                                style={{ overflowX: 'hidden' }}
                                slidesPerView={5}
                                slidesPerGroup={5}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 2,
                                        slidesPerGroup: 2,
                                    },
                                    400: {
                                        slidesPerView: 3,
                                        slidesPerGroup: 3,
                                    },
                                    617: {
                                        slidesPerView: 4,
                                        slidesPerGroup: 4,
                                    },
                                    900: {
                                        slidesPerView: 5,
                                        slidesPerGroup: 5,
                                    }
                                }}
                                mousewheel={{
                                    forceToAxis: false,
                                }}
                                navigation={{
                                    nextEl: navigationButtons?.nextButtonRef?.current,
                                    prevEl: navigationButtons?.prevButtonRef?.current,
                                }}
                                onSwiper={(swiper) => {
                                    updateNavigation(swiper);
                                }}
                                pagination={{
                                    clickable: isNavigation ? true : false,
                                    enabled: isNavigation ? true : false,
                                }}
                                modules={[Navigation, Mousewheel, Pagination]}
                            >
                                {group.map((elem, i) => {
                                    const name = lang === 'en' ? elem?.nombreIng || elem?.nombre : elem?.nombre;
                                    return (
                                        <SwiperSlide
                                            className="focusable-by-children-secondary d-flex justify-content-center px-1"
                                            key={`pais${i}`}
                                        >
                                            <Link
                                                key={`${category}-${i}`}
                                                to={elem?.url}
                                                className="cardCountry"
                                            >
                                                <div>
                                                    <Img src={`${ASSETS_URL}${elem?.imgUrl}`} alt={elem?.nombre} className="w-100" />
                                                    <p className="w-100  text-center secondary-font una-linea-texto" style={{ fontWeight: 600 }}>{name || 'N/A'}</p>
                                                </div>
                                            </Link>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>

                            :
                            <Swiper
                                className="main-covers"
                                style={{ overflowX: 'hidden' }}
                                slidesPerGroup={6}
                                slidesPerView={6}
                                breakpoints={{
                                    1150: {
                                        slidesPerView: 6,
                                        slidesPerGroup: 6,
                                    },
                                    1200: {
                                        slidesPerView: 5,
                                        slidesPerGroup: 5,
                                    },
                                    1400: {
                                        slidesPerView: 6,
                                        slidesPerGroup: 6,
                                    },
                                    1500: {
                                        slidesPerView: 7,
                                        slidesPerGroup: 7,
                                    },
                                    1700: {
                                        slidesPerView: 8,
                                        slidesPerGroup: 8,
                                    },
                                    1900: {
                                        slidesPerView: 9,
                                        slidesPerGroup: 9,
                                    },
                                    2200: {
                                        slidesPerView: 10,
                                        slidesPerGroup: 10,
                                    }
                                }}
                                mousewheel={{
                                    forceToAxis: true,
                                }}
                                navigation={{
                                    nextEl: navigationButtons?.nextButtonRef?.current,
                                    prevEl: navigationButtons?.prevButtonRef?.current,
                                }}
                                onSwiper={(swiper) => {
                                    updateNavigation(swiper);
                                }}
                                modules={[Navigation, Mousewheel, A11y]}
                                a11y={{
                                    containerMessage: texts.getText({ id: "countries.containerMessage", defaultText: "lista de paises" }),
                                    itemRoleDescriptionMessage: texts.getText({ id: "countries.itemRoleDescriptionMessage", defaultText: "agrupacion de paises" })
                                }}
                                onSlideChange={(swiper) => {
                                    const status = document.getElementById("carousel-countries-status");
                                    if (status) {
                                        status.textContent = `${texts.getText({ id: "countries.onSlideChange", defaultText: "grupo" })}  ${swiper.realIndex + 1}`;
                                    }
                                }}
                            >
                                {group.map((elem, i) => {
                                    const name = lang === 'en' ? elem?.nombreIng || elem?.nombre : elem?.nombre;
                                    return (
                                        <SwiperSlide
                                            className="d-flex justify-content-center"
                                            key={`banner${i}`}

                                        >
                                            <Link
                                                key={`${category}-${i}`}
                                                to={elem?.url}
                                                className="cardReadingList focusable-red"
                                                style={{
                                                    minWidth: 150,
                                                    maxWidth: 150,
                                                    height: "auto",
                                                }}
                                                aria-label={`${texts?.getText({ id: "countries.go_to", defaultText: "Ir al pais" })} ${name || 'N/A'}`}
                                            >
                                                <div>
                                                    <Img src={`${ASSETS_URL}${elem?.imgUrl}`} alt={elem?.nombre} className="w-100" />
                                                    <p className="w-100  text-center secondary-font" style={{ fontWeight: 600 }}>{name || 'N/A'}</p>
                                                </div>
                                            </Link>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                    }
                    <div aria-live="polite" className="sr-only" id="carousel-countries-status"></div>
                </div>
            </div>
        </div>
        </>
    )
}
